import { LoginForm, LoginLayout } from "features/login";
import { useCheckLoginStatus } from "Hooks";

export const Login = () => {
  useCheckLoginStatus();
  return <LoginLayout form={<LoginForm />} />;
};
